export function roundUpToTwoDecimals(num: number) {
    return Number((Math.ceil(num * 100) / 100).toFixed(2))
}
